export default __webpack_public_path__ + "static/media/heading-mark.99f35bd2.svg";